export type ThemeMode = "light" | "dark";

export type ThemeTokens = {
  background: string;
  surface: string;
  surfaceAlt: string;
  border: string;
  textPrimary: string;
  textSecondary: string;
  primary: string;
  primarySoft: string;
  success: string;
  warning: string;
  danger: string;
  shadow: string;
  glass: string;
};

export const darkTokens: ThemeTokens = {
  background: "#101114",
  surface: "rgba(255,255,255,0.03)",
  surfaceAlt: "#1A1C21",
  border: "rgba(255,255,255,0.06)",

  textPrimary: "#F2F2EE",
  textSecondary: "#AAA79F",

  primary: "#D1A14A",
  primarySoft: "rgba(209,161,74,0.14)",

  success: "#6BA27D",
  warning: "#C89034",
  danger: "#B9645F",

  shadow: "0 10px 26px rgba(0,0,0,0.30)",
  glass: "blur(12px)"
};

export const lightTokens: ThemeTokens = {
  background: "#F3F2EE",
  surface: "rgba(255,255,255,0.75)",
  surfaceAlt: "#FFFFFF",
  border: "rgba(30,30,32,0.08)",

  textPrimary: "#1F1F21",
  textSecondary: "#6E6C65",

  primary: "#C89232",
  primarySoft: "rgba(200,146,50,0.12)",

  success: "#5E9272",
  warning: "#BA7E2A",
  danger: "#B45A54",

  shadow: "0 10px 26px rgba(0,0,0,0.08)",
  glass: "blur(12px)"
};